var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PlanEdition", {
        ref: "editionStructure",
        on: {
          "retour-ajout-structure": function($event) {
            return _vm.surRetourAjoutSructure($event)
          },
          "structure-supprimee": function($event) {
            _vm.setUrl()
            _vm.$router.go()
          }
        }
      }),
      _c("ModalDuplicationMenu", {
        ref: "modalDuplicationMenu",
        attrs: {
          disabled: _vm.donneesModifiees,
          menuPlanId: _vm.menu && _vm.menu.menuPlanId,
          lundiDeLaSemaine: _vm.lundiDeLaSemaine,
          menuSurPlanAlimentaire: _vm.menu && _vm.menu.menuSurPlanAlimentaire
        },
        on: {
          "menu-duplique": function($event) {
            return _vm.surDuplication()
          }
        }
      }),
      _c(
        "b-modal",
        {
          attrs: {
            size: "md",
            title: "Options d'export",
            "ok-title": "Exporter",
            "ok-disabled": _vm.enExportation,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              return _vm.exporter(_vm.menu)
            }
          },
          model: {
            value: _vm.afficherOptionsExport,
            callback: function($$v) {
              _vm.afficherOptionsExport = $$v
            },
            expression: "afficherOptionsExport"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body form-check background-primary form-check-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramExport.afficherPrix,
                          expression: "paramExport.afficherPrix"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "afficherPrix" },
                      domProps: {
                        checked: Array.isArray(_vm.paramExport.afficherPrix)
                          ? _vm._i(_vm.paramExport.afficherPrix, null) > -1
                          : _vm.paramExport.afficherPrix
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.paramExport.afficherPrix,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherPrix",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherPrix",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.paramExport, "afficherPrix", $$c)
                          }
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "afficherPrix" }
                      },
                      [_vm._v("Afficher les prix ?")]
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body form-check background-primary form-check-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramExport.afficherEffectif,
                          expression: "paramExport.afficherEffectif"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "afficherEffectif" },
                      domProps: {
                        checked: Array.isArray(_vm.paramExport.afficherEffectif)
                          ? _vm._i(_vm.paramExport.afficherEffectif, null) > -1
                          : _vm.paramExport.afficherEffectif
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.paramExport.afficherEffectif,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherEffectif",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherEffectif",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.paramExport, "afficherEffectif", $$c)
                          }
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "afficherEffectif" }
                      },
                      [_vm._v("Afficher les effectifs ?")]
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body form-check background-primary form-check-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramExport.afficherAllergenes,
                          expression: "paramExport.afficherAllergenes"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "afficherAllergenes" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.paramExport.afficherAllergenes
                        )
                          ? _vm._i(_vm.paramExport.afficherAllergenes, null) >
                            -1
                          : _vm.paramExport.afficherAllergenes
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.paramExport.afficherAllergenes,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherAllergenes",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherAllergenes",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.paramExport, "afficherAllergenes", $$c)
                          }
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "afficherAllergenes" }
                      },
                      [_vm._v("Afficher les allergènes dans le menu ?")]
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body form-check background-primary form-check-inline"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paramExport.afficherIngredients,
                          expression: "paramExport.afficherIngredients"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "afficherIngredients" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.paramExport.afficherIngredients
                        )
                          ? _vm._i(_vm.paramExport.afficherIngredients, null) >
                            -1
                          : _vm.paramExport.afficherIngredients
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.paramExport.afficherIngredients,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherIngredients",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.paramExport,
                                  "afficherIngredients",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.paramExport,
                              "afficherIngredients",
                              $$c
                            )
                          }
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "afficherIngredients" }
                      },
                      [_vm._v("Afficher les ingrédients dans le menu ?")]
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: "md",
            title: "Créer un menu",
            "ok-title": _vm.planAlimentaireSelectionneId
              ? "Créer les semaines de menus pour ce plan alimentaire"
              : "Créer le menu",
            "ok-disabled": _vm.estLectureSeule,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              return _vm.creerMenuAvecPlan(_vm.planId, true)
            }
          },
          model: {
            value: _vm.montrerModalPlanAlimentaire,
            callback: function($$v) {
              _vm.montrerModalPlanAlimentaire = $$v
            },
            expression: "montrerModalPlanAlimentaire"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _vm.optionsPlansAlimentaires && _vm.optionsPlansAlimentaires.length
              ? _c(
                  "div",
                  { staticClass: "col-12 no-padding push-top-1rem" },
                  [
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "value-field": "id",
                          "text-field": "nom",
                          options: _vm.optionsPlansAlimentaires
                        },
                        model: {
                          value: _vm.planAlimentaireSelectionneId,
                          callback: function($$v) {
                            _vm.planAlimentaireSelectionneId = $$v
                          },
                          expression: "planAlimentaireSelectionneId"
                        }
                      },
                      [
                        _c("template", { slot: "first" }, [
                          _c(
                            "option",
                            {
                              attrs: { selected: "" },
                              domProps: { value: null }
                            },
                            [_vm._v("Aucun")]
                          )
                        ])
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.menuOuPlanEnCours && _vm.menuOuPlanEnCours.estUneDeclinaison
              ? _c("div", { staticClass: "col-12" }, [
                  _c("label", { staticClass: "label-checkbox mb-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.importerMenuUniversel,
                          expression: "importerMenuUniversel"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        disabled: !_vm.menuOuPlanEnCours.menuUniverselDisponible
                      },
                      domProps: {
                        checked: Array.isArray(_vm.importerMenuUniversel)
                          ? _vm._i(_vm.importerMenuUniversel, null) > -1
                          : _vm.importerMenuUniversel
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.importerMenuUniversel,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.importerMenuUniversel = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.importerMenuUniversel = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.importerMenuUniversel = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v("Importer menu Agap'pro")
                    ])
                  ]),
                  !_vm.menuOuPlanEnCours.menuUniverselDisponible
                    ? _c("div", { staticClass: "warning" }, [
                        _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                        _vm._v(
                          " Aucun menu Agap'pro n'est encore disponible pour cette semaine"
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xxl",
            title: _vm.titreModalRecette,
            "hide-footer": ""
          },
          on: { hide: _vm.cacherModalRecette },
          model: {
            value: _vm.montrerModalRecette,
            callback: function($$v) {
              _vm.montrerModalRecette = $$v
            },
            expression: "montrerModalRecette"
          }
        },
        [
          _c(
            "template",
            { slot: "default" },
            [
              _c("RecetteListe", {
                attrs: {
                  menu: _vm.menu,
                  recetteList: _vm.recetteList,
                  composanteId: _vm.composanteId,
                  cleComposee: _vm.cleComposee,
                  serviceId: _vm.serviceId,
                  recetteId: _vm.recetteId,
                  composanteEffectif: _vm.composanteEffectif,
                  regimeIdsInit: _vm.regimesModalRecette,
                  textureIdsInit: _vm.texturesModalRecette,
                  categoriesGEMRCNIdsInit: _vm.categoriesGEMRCNModalRecette
                },
                on: { "changement-recette": _vm.surChangementRecette }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _vm.montrerCreerMenuAvecPlan
            ? _c(
                "div",
                { staticClass: "col-12 text-center push-top-2rem" },
                [
                  _vm.estLectureSeule
                    ? [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-secondary",
                            staticStyle: {
                              "margin-bottom": "1rem",
                              "margin-right": "10rem"
                            },
                            attrs: { disabled: _vm.estLectureSeule },
                            on: {
                              click: function($event) {
                                return _vm.creerMenuAvecPlan(_vm.planId, false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " Aucun menu n'existe pour cette période sur " +
                                _vm._s(_vm.nomDuPlanDeMenu) +
                                " "
                            )
                          ]
                        )
                      ]
                    : [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-primary",
                            staticStyle: {
                              "margin-bottom": "1rem",
                              "margin-right": "10rem"
                            },
                            attrs: { disabled: _vm.estLectureSeule },
                            on: {
                              click: function($event) {
                                return _vm.creerMenuAvecPlan(_vm.planId, false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " Créer une semaine " +
                                _vm._s(_vm.nomDuPlanDeMenu) +
                                " "
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            : _vm._e(),
          _vm.montrerLeMenu
            ? _c("MenusEdition", {
                key: _vm.menuEditionId,
                ref: "editionDetails",
                attrs: {
                  menu: _vm.menu,
                  composanteId: _vm.composanteId,
                  lundiDeLaSemaine: _vm.lundiDeLaSemaine,
                  lectureSeule: _vm.estLectureSeule
                },
                on: {
                  "effacement-recette": _vm.checkDonneesModifiees,
                  "duplication-recette": _vm.checkDonneesModifiees,
                  "effectif-changed": _vm.checkDonneesModifiees
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }